<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import TwoColumnDetailLayout from 'dashboard/components-next/TwoColumnDetailLayout.vue';
import ContactDetailSidebar from 'dashboard/components-next/Contacts/ContactDetail/ContactDetailSidebar.vue';
import InPlaceConversationPanel from 'dashboard/components-next/Conversation/InPlaceConversationPanel.vue';
import LinkedEntityPane from 'dashboard/components-next/LinkedEntityPane.vue';
import TimelineChat from 'dashboard/components-next/Timeline/TimelineChat.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();

const contactId = computed(() => Number(route.params.contactId));
const getContactById = useMapGetter('contacts/getContactById');
const uiFlags = useMapGetter('contacts/getUIFlags');

const contact = computed(() => getContactById.value(contactId.value));
const isFetching = computed(() => uiFlags.value.isFetchingItem);

onMounted(() => {
  store.dispatch('contacts/show', { id: contactId.value });
});

// Conversa aberta no painel da direita (no lugar do Historico)
const activeConversationId = ref(null);

const goBack = () => {
  if (activeConversationId.value) {
    activeConversationId.value = null;
    return;
  }
  if (window.history.state?.back) {
    router.back();
    return;
  }
  router.push({
    name: 'contacts_dashboard_index',
    params: { accountId: route.params.accountId },
  });
};

// --- Historico recarrega sozinho quando algo do contato muda na coluna esquerda ---
const timelineChatRef = ref(null);
const handleContactUpdated = () => {
  timelineChatRef.value?.refetch();
};
const handleLinkedUpdated = handleContactUpdated;
</script>

<template>
  <TwoColumnDetailLayout
    :is-loading="isFetching"
    :has-data="!!contact?.id"
    :storage-key="LOCAL_STORAGE_KEYS.CONTACT_DETAIL_SIDEBAR_WIDTH"
  >
    <template #sidebar>
      <LinkedEntityPane
        :key="contact.id"
        :active-conversation-id="activeConversationId"
        @open-conversation="id => (activeConversationId = id)"
        @close-conversation="activeConversationId = null"
        @linked-updated="handleLinkedUpdated"
      >
        <ContactDetailSidebar
          :contact="contact"
          @back="goBack"
          @updated="handleContactUpdated"
        />
      </LinkedEntityPane>
    </template>
    <template #timeline>
      <InPlaceConversationPanel
        v-if="activeConversationId"
        :conversation-id="activeConversationId"
      />
      <TimelineChat
        v-else
        ref="timelineChatRef"
        subject-type="Contact"
        :subject-id="contact.id"
      />
    </template>
  </TwoColumnDetailLayout>
</template>
